import { render, staticRenderFns } from "./BuildingSettingsPage.vue?vue&type=template&id=328172ca&scoped=true&"
import script from "./BuildingSettingsPage.vue?vue&type=script&lang=js&"
export * from "./BuildingSettingsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328172ca",
  null
  
)

export default component.exports